// <product-tabs> — bouwt een kleine tab-strip uit de panelen die erin staan.
// Elk paneel heeft data-tab-title; de knoppen worden hieruit gegenereerd.
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.nav = this.querySelector('.product-tabs__nav');
    this.panels = Array.from(this.querySelectorAll('.product-tabs__panel'));
    if (!this.nav || this.panels.length === 0) return;

    // Nav opnieuw opbouwen (voorkomt dubbele knoppen bij re-render in de editor).
    this.nav.innerHTML = '';
    this.buttons = this.panels.map((panel, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-tabs__tab';
      btn.textContent = panel.dataset.tabTitle || `Tab ${i + 1}`;
      btn.setAttribute('role', 'tab');
      btn.addEventListener('click', () => this.select(i));
      this.nav.appendChild(btn);
      return btn;
    });

    this.select(0);

    // Theme-editor: activeer het paneel dat de merchant selecteert.
    this.addEventListener('shopify:block:select', (e) => {
      const panel = e.target.closest('.product-tabs__panel');
      if (panel && this.panels.includes(panel)) this.select(this.panels.indexOf(panel));
    });
  }

  select(index) {
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
    this.buttons.forEach((btn, i) => {
      btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('product-tabs')) {
  customElements.define('product-tabs', ProductTabs);
}
